/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffMemoryAnswerImage200Response
 */
export interface PostLiffMemoryAnswerImage200Response {
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryAnswerImage200Response
     */
    filePath?: string;
}

/**
 * Check if a given object implements the PostLiffMemoryAnswerImage200Response interface.
 */
export function instanceOfPostLiffMemoryAnswerImage200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostLiffMemoryAnswerImage200ResponseFromJSON(json: any): PostLiffMemoryAnswerImage200Response {
    return PostLiffMemoryAnswerImage200ResponseFromJSONTyped(json, false);
}

export function PostLiffMemoryAnswerImage200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffMemoryAnswerImage200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
    };
}

export function PostLiffMemoryAnswerImage200ResponseToJSON(value?: PostLiffMemoryAnswerImage200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filePath': value.filePath,
    };
}

